<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/parentList' }">
					<i class="el-icon-lx-group"></i> 家长管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>更新家长信息</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'头像'" prop="haaPHOT">
							<el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" :on-change="uploadImg">
								<img v-if="ruleForm.haaPHOT" mode='aspectFill' :src="ruleForm.haaPHOT" :onerror="defaultImg" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="12"></el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'家长ID'" prop="haaMSID">
							<el-input v-model="ruleForm.haaMSID" :placeholder="'请输入家长ID'" :disabled="true"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="'手机号码'" prop="haaPHON">
							<el-input v-model="ruleForm.haaPHON" :placeholder="'请输入手机号码'" :disabled="true"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'姓名'" prop="haaNAME">
							<el-input v-model="ruleForm.haaNAME" :placeholder="'请输入姓名'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="'手机系统'" prop="haaDEFG">
							<el-radio-group v-model="ruleForm.haaDEFG">
								<el-radio label="1">Android</el-radio>
								<el-radio label="0">IOS</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item :label="'生日'" prop="haaBIRT" class="font">
							<el-date-picker v-model="ruleForm.haaBIRT" type="date" :placeholder="'请选择日期'" value-format="yyyy/MM/dd" align="center"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="14">
						<el-form-item :label="'性别'" prop="haaGSEX">
							<el-radio-group v-model="ruleForm.haaGSEX">
								<el-radio label="1">男</el-radio>
								<el-radio label="0">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<!--<el-row>
					<el-col :span="24">
						<el-form-item :label="'昵称'" prop="haaNICK" v-if="false">
						 <el-input v-model="ruleForm.haaNICK" :placeholder="'请输入昵称'" maxlength="20"></el-input>
						</el-form-item>
					</el-col>  
				</el-row>
				<el-row>
				  <el-col :span="8">
				  	 <el-form-item :label="'推送ID'" prop="haaPHID" v-if="false">
				  	  <el-input v-model="ruleForm.haaPHID" :placeholder="'请输入推送ID'" ></el-input>
				  	 </el-form-item>
				  </el-col>        
				  <el-col :span="8">
				  	 <el-form-item :label="'微信ID'" prop="haaWXID" v-if="false">
				  	  <el-input v-model="ruleForm.haaWXID" :placeholder="'请输入微信ID'"></el-input>
				  	 </el-form-item>
				  </el-col>        
				  <el-col :span="8">
				  	 <el-form-item :label="'苹果ID'" prop="haaAPID" v-if="false">
				  	  <el-input v-model="ruleForm.haaAPID" :placeholder="'请输入苹果ID'"></el-input>
				  	 </el-form-item>
				  </el-col>        
				  </el-row> -->
				<!-- <el-row>
					<el-col :span="23">
						<el-form-item :label="'删除状态'" prop="haaDELF">
							<el-select v-model="ruleForm.haaDELF" clearable :placeholder="'请选择删除状态'" class="handle-select mr10">
								<el-option v-for="item in ruleForm.optionsDELF" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<!-- vueCropper 剪裁图片实现-->
			<el-dialog :title="'剪裁图片'" :visible.sync="imgCutVisible" append-to-body>
				<div class="cropper-content">
					<div class="cropper" style="text-align:center">
						<vueCropper ref="cropper" :img="imgCutOption.img" :outputSize="imgCutOption.size" :outputType="imgCutOption.outputType"
						 :info="true" :full="imgCutOption.full" :canMove="imgCutOption.canMove" :canMoveBox="imgCutOption.canMoveBox"
						 :original="imgCutOption.original" :autoCrop="imgCutOption.autoCrop" :fixed="imgCutOption.fixed" :fixedNumber="imgCutOption.fixedNumber"
						 :centerBox="imgCutOption.centerBox" :infoTrue="imgCutOption.infoTrue" :fixedBox="imgCutOption.fixedBox"></vueCropper>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="imgCutVisible = false">返回</el-button>
					<el-button type="primary" @click="finish">提交</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'editParent',
		inject: ['reload'],
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					callback();
				}
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				haaChangeData: {},
				imgCutVisible: false,
				imgCutOption: {
					img: '', // 裁剪图片的地址
					info: true, // 裁剪框的大小信息
					outputSize: 0.9, // 裁剪生成图片的质量
					outputType: 'jpg', // 裁剪生成图片的格式
					canScale: true, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					fixedBox: false, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: false, // 是否输出原图比例的截图
					canMoveBox: true, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
				},
				defaultImg: 'this.src="' + require("../../assets/img/users_128.png") + '";this.onerror=null',
				ruleForm: {
					haaMSID: '',
					haaPHON: '',
					haaDEFG: '0',
					haaPHID: '',
					haaWXID: '',
					haaAPID: '',
					haaNAME: '',
					haaNICK: '',
					haaPHOT: '',
					imgbase64: '',
					haaGSEX: '1',
					haaBIRT: '',
					haaDELF: '',
					optionsDELF: []
				},
				rules: {
					haaNAME: [{
						validator: validateFontSize
					}],
					// haaNICK:[
					// 	{ 
					// 	 validator: validateFontSize
					// 	}
					// ]
				}
			};
		},
		watch: {
			$route(to, from) {
				if (to.name === "editParent") {
					this.dummyCreated();
				}
			}
		},
		created() {
			this.haaMSID = this.$route.query.HAAMSID;
			// this.getDELF(); //获取删除状态
			this.getData(this.haaMSID);
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			dummyCreated() {
				this.haaMSID = this.$route.query.HAAMSID;
				this.getDELF(); //获取删除状态
				this.getData(this.haaMSID);
			},
			//上传头像
			uploadImg(file, fileList) {
				var that = this
				//判断图片类型
				if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/png' || file.raw.type == 'image/JPG') {
					var isJPG = true
				} else {
					isJPG = false
				}
				// 判断图片大小
				const isLt2M = file.raw.size / 1024 / 1024 < 20
				if (!isJPG) {
					that.$message.error('上传产品图片只能是 JPG/PNG/JPEG 格式!') //上传产品图片只能是 JPG/PNG/JPEG 格式!
					return false;
				}
				if (!isLt2M) {
					that.$message.error('上传产品图片大小不能超过 20MB!') //上传产品图片大小不能超过 20MB!
					return false;
				}

				if (isJPG && isLt2M) {
					var reader = new FileReader();
					reader.readAsDataURL(file.raw);
					reader.onload = function(e) {
						that.imgCutOption.img = this.result;
						that.imgCutVisible = true;
					}
				}
			},
			// 剪切图片确定方法
			finish() {
				this.$refs.cropper.getCropBlob((data) => {
					var reader = new FileReader();
					reader.readAsDataURL(data);
					var that = this;
					reader.onload = function(e) {
						that.ruleForm.haaPHOT = this.result;
						that.ruleForm.imgbase64 = this.result;
						that.imgCutVisible = false;
					}
				})
			},
			//获取删除信息
			getDELF() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10005 //删除 10005
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsDELF = response.data.KKDT;
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取删除状态请求失败', //请求失败
							type: 'error'
						});

					});
			},
			//获取宝宝信息
			getData(haaMSID) {
				const self = this;
				var postUrl = 'WCF/WEB/svcHAA.svc/GET_HAA_BYID';
				//debugger;
				//console.log(haaMSID);
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self.web_sphon,
							sMSID: haaMSID //会社ID
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status;
						if (resStatus == "200") { //网络请求成功
							let resCount = response.data.KKDTCOUNT;
							if (resCount > 0) {
								//返回列信息赋值到页面上 
								this.ruleForm.haaMSID = response.data.KKDT[0].HAAMSID; //会社ID
								this.ruleForm.haaPHON = response.data.KKDT[0].HAAPHON; //会社ID
								this.ruleForm.haaDEFG = response.data.KKDT[0].HAADEFG; //会社ID
								this.ruleForm.haaPHID = response.data.KKDT[0].HAAPHID; //会社名称
								this.ruleForm.haaWXID = response.data.KKDT[0].HAAWXID; //片假名
								this.ruleForm.haaAPID = response.data.KKDT[0].HAAAPID; //片假名
								this.ruleForm.haaPHOT = response.data.KKDT[0].HAAPHOT + "?timestamp=" + new Date().getTime(); //头像
								this.ruleForm.haaNICK = response.data.KKDT[0].HAANICK; //片假名
								this.ruleForm.haaNAME = response.data.KKDT[0].HAANAME; //片假名
								this.ruleForm.haaGSEX = response.data.KKDT[0].HAAGSEX; //会社種類（前）
								this.ruleForm.haaDELF = response.data.KKDT[0].HAADELF; //会社種類（前）
								this.ruleForm.haaBIRT = response.data.KKDT[0].HAABIRT; //会社種類（後）

								this.haaChangeData = response.data.KKDT[0];

							} else {
								this.$message({
									message: '获取数据失败', //无数据
									type: 'error'
								});
							}
						} else {
							this.$message({
								message: '请求获取数据失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '请求获取数据失败', //请求失败
							type: 'error'
						});
					});
			},
			//保存会社信息
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {

						const self = this;


						var valDELF;
						if (self.ruleForm.haaDELF == "undefined") {
							valDELF = '';
						} else {
							valDELF = self.ruleForm.haaDELF;
						}

						let haaFlag = false;
						if (this.haaChangeData.HAAPHID != this.ruleForm.haaPHID) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAAWXID != this.ruleForm.haaWXID) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAAAPID != this.ruleForm.haaAPID) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAANAME != this.ruleForm.haaNAME) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAANICK != this.ruleForm.haaNICK) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAAPHOT != this.ruleForm.imgbase64) {
							haaFlag = true;
						}

						if (this.haaChangeData.HAABIRT != this.ruleForm.haaBIRT) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAADEFG != this.ruleForm.haaDEFG) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAAGSEX != this.ruleForm.haaGSEX) {
							haaFlag = true;
						}
						if (this.haaChangeData.HAADELF != valDELF) {
							haaFlag = true;
						}


						var postUrl = 'WCF/WEB/svcHAA.svc/UPD_HAA_BYID';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									sMSID: self.haaMSID, //宝宝ID
									sHAADEFG: this.ruleForm.haaDEFG,
									sHAAPHID: self.ruleForm.haaPHID,
									sHAAWXID: self.ruleForm.haaWXID,
									sHAAAPID: self.ruleForm.haaAPID,
									sHAAPHOT: self.ruleForm.imgbase64,
									sHAANICK: self.ruleForm.haaNICK,
									sHAANAME: self.ruleForm.haaNAME,
									sHAAGSEX: this.ruleForm.haaGSEX,
									sHAADELF: valDELF,
									sHAABIRT: self.ruleForm.haaBIRT
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '家长信息更新失败', //编辑失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('家长信息更新成功'); // 编辑成功
										this.$router.push('/parentList') // 跳转路由到用户列表页
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "editParent") {
												indexs = i;
												break;
											}
										}
										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '请求更新家长信息失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '请求更新家长信息失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '信息更新失败', //表单验证失败
							type: 'error'
						});
						return false;
					}
				});
			},
			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "editParent") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			}
		}
	}
</script>
<style scoped>
	.avatar-uploader>>>.el-upload--text {
		background-color: #fff;
		border: 1px solid #d9d9d9;
		border-radius: 128px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 128px;
		height: 128px;
		text-align: center;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}

	.el-dialog__footer {
		text-align: center;
		height: 80px;
	}

	.el-dialog__footer button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.select-shop .el-input {
		width: 300px;
	}

	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 16px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}

	.avatar-uploader .el-upload {
		width: 128px;
		height: 128px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
